import script from "./BaseSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&setup=true&lang=js"

import "./BaseSwiper.vue?vue&type=style&index=0&id=de761b64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de761b64"]])

export default __exports__